<script setup>
    import {
        useRouter
    } from 'vue-router';
    import {
        Fold,
        Expand,
        BellFilled,
        ArrowDown,
        ArrowRight
    } from '@element-plus/icons-vue';
    import {
        ElMessage,
        ClickOutside as vClickOutside
    } from 'element-plus';
    import {
        computed,
        onMounted,
        ref,
        unref,
        inject,
        watch,
        onBeforeUnmount
    } from 'vue';
    import {
        useStore
    } from 'vuex';
    import {
        require
    } from '@/utils/index';

    const emit = defineEmits(['toggle-mobile-menu']);
    import {
        getFontMsgApi
    } from '@/apis/common';
    import {
        Vue3Marquee
    } from 'vue3-marquee';
    import Breadcrumb from '../Breadcrumb';
    import language from '@/layout/components/language.vue';
    import profile_avatar from '@/assets/images/center/profile_avatar.png';
    import {
        readContent
    } from '@/apis/common'

    const langrage = inject('langrage');
    const router = useRouter();
    const store = useStore();
    const sidebarOpen = computed(() => store.state.sidebarOpen);
    const userInfo = computed(() => store.state.user.userInfo);
    const notificationVisible = ref(false)
    const toggleNotificationPanel = () => {
        notificationVisible.value = !notificationVisible.value
    }
    const userMessage = computed(() =>
        store.state.user.userMessage
    )
    console.log('主页数据', store.state.user.userMessage);
    const badge = ref('')
    watch(userMessage, (nv) => {
        if (nv.length) {
            badge.value = 0
            nv.forEach(el => {
                if (el.isRead == 2) {
                    badge.value = Number(badge.value) + 1
                }
            });
            if (!badge.value) {
                badge.value = ''
            }
        } else {
            badge.value = ''
        }
        // nv.length ? badge.value = nv.length : badge.value = ''
        // badge.value = nv.length
    }, {
        deep: true
    })
    const fontMsg = ref({});
    const fontFamily = ref('');
    const subUser = ref(userInfo.value['user']);
    const lang = localStorage.getItem('langrage');
    const visible = ref(false)
    console.log('userInfo:', subUser);
    const handleCommand = (command) => {
        ElMessage(`click on item ${command}`);
    };

    const changeSidebar = () => {
        store.commit('TOGGLE_SIDEBAR');
    };

    const jumpPage = (path) => {
        router.push(path);
        setTimeout(() => {
            location.reload();
        }, 100);
    };

    // 获取公告信息
    const getFontMsg = async () => {
        try {
            const {
                data,
                code,
                msg
            } = await getFontMsgApi();
            fontMsg.value = data;
            fontFamily.value = `'Be Vietnam Pro', 'source-han-sans', sans-serif`;
        } catch (error) {
            console.error(error);
        }
    };

    const changeType = async (item) => {
        console.log('先进入');


        let Timer = null

        if (item.isRead == 2) {
            //先前端改变状态,让使用变得丝滑
            store.commit('user/CHANGE_MESSAGE_TYPE', item.id)
            //然后找到传来的id,调接口把未读变为已读
            await readContent({
                userId: userInfo.value.user.userId,
                id: item.id
            })
            //要做个防抖,我们只更新最后一次的消息数据,防止点了未读马上调接口回头影响其他数据
            if (Timer) {
                clearTimeout(Timer)
            }
            Timer = setTimeout(async () => {
                //获取铃铛信息
                await store.dispatch('user/getRemindContent');
            }, 500)
        } else if (!item) {
            //如果传的是空就是一键已读,调接口
            console.log(1, '如果不存在item');
            visible.value = false
            await readContent({
                userId: userInfo.value.user.userId,
                id: null
            })
            console.log(2);
            //获取铃铛信息
            await store.dispatch('user/getRemindContent');
            console.log(3);

        }

    }
    const goMessage = () => {
        router.push('/account/profile');
    };
    const checkIn = async () => {
        //localStorage.clear();
        await store.dispatch('user/logout');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('response');
        localStorage.removeItem('token');
        window.location.reload();
    };
    const isMobile = ref(false)
    const MOBILE_BREAKPOINT = 1024

    // 检查屏幕宽度的函数
    const checkScreenSize = () => {
        isMobile.value = window.innerWidth <= MOBILE_BREAKPOINT
    }

    // 监听窗口大小变化
    const handleResize = () => {
        checkScreenSize()
    }

    onMounted(() => {
        getFontMsg();
        const dropDownTrigger = document.getElementById('popover')
        console.log(dropDownTrigger);

        dropDownTrigger.addEventListener('mouseenter', () => {
            visible.value = true
            console.log('userMessage', userMessage);
            console.log('userMessage', store.state.user.userMessage);
        });
        dropDownTrigger.addEventListener('mouseleave', () => {
            if (!store.state.user.userMessage.length) {
                visible.value = false
            }
        });
        checkScreenSize()
        window.addEventListener('resize', handleResize)

    });
    // 组件卸载前移除事件监听器
    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize)
    })
</script>

<template>
    <div class="navbar">
        <div class="left flex-center">
            <!-- 桌面端显示原来的菜单按钮 -->
            <!-- <div class="icon" @click="changeSidebar" v-if="!isMobile">
                <img :style="{
                    transform: sidebarOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                }" src="@/assets/images/center/menuFold.png" alt="" />
            </div> -->

            <!-- 移动端显示汉堡菜单按钮 -->
            <div class="mobile-menu-icon" @click="$emit('toggle-mobile-menu')" v-if="isMobile">
                <img src="@/assets/images/center/menuFold.png" alt="" />
            </div>

            <!-- 桌面端显示面包屑 -->
            <div v-if="!isMobile">
                <Breadcrumb />
            </div>
        </div>

        <!-- 桌面端显示公告 -->
        <div class="tips" style="font-size: 1.4rem; width: 92rem" v-if="!isMobile">
            <!-- <Vue3Marquee :duration="lang == 'chinese' ? fontMsg.flowSecond : fontMsg.flowSecond2" :pauseOnHover="true">
                <span v-if="lang == 'chinese'" :style="{ fontFamily: fontFamily, color: fontMsg.colors }">{{
                    fontMsg.valueInfo
                    }}</span>
                <span v-if="lang == 'english'" :style="{ fontFamily: fontFamily, color: fontMsg.colors }">{{
                    fontMsg.valueInfo2
                    }}</span>
            </Vue3Marquee> -->
        </div>

        <div class="right flex-center">
            <!-- 桌面端显示的内容 -->
            <template v-if="!isMobile">
                <!-- <div style="height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 1rem;">
                    <img style="cursor: pointer; width: 4rem" :src="require('@/assets/images/center/kefu.png')" alt="">
                </div> -->
                <!-- 消息拉框 -->
                <el-popover :visible="visible" placement="bottom" :width="360" :height="260">
                    <div class="popover_content">
                        <p v-if="userMessage.length" class="popover_title" style="text-align: center;margin: 0;">{{
                            langrage['dashboard31'] }}</p>
                        <div class="popover_tip_content">
                            <div v-if="userMessage.length" class="popover_text_content"
                                v-for="(item, index) in userMessage" :key="index">
                                <div class="num_content">
                                    <p class="num">{{ index + 1 }}</p>
                                    <p class="popover_text">
                                        {{ item.pushInfo }}
                                    </p>
                                </div>
                                <div class="popover_type" @click="changeType(item)"
                                    :class="item.isRead == 2 ? 'blue' : ''">
                                    <!-- 35已读36未读 -->
                                    {{ item.isRead == 2 ? langrage['dashboard36'] :
                                        langrage['dashboard35']
                                    }}
                                </div>
                            </div>
                            <div v-else style="text-align: center;margin: 0;">{{ langrage['dashboard38'] }}</div>
                        </div>
                        <div v-if="userMessage.length" style="text-align: right; margin: 0"
                            class="popover_botton_content">
                            <el-button size="small" text @click="visible = false" class="">{{ langrage['dashboard37']
                            }}</el-button>
                            <el-button size="small" @click="changeType('')" color="#2b6bff" type="primary" class="">
                                {{ langrage['dashboard32'] }}
                            </el-button>
                        </div>
                    </div>
                    <template #reference>
                        <div class="popover-case" id="popover">
                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                            </svg>
                        </div>
                    </template>
                </el-popover>
                <!-- <div class="btn flex-center" @click="jumpPage('/account/CDKEY')"
                    style="margin:0 2rem;justify-content: flex-start;padding:0 1rem;box-sizing: border-box;">
                    <img class="icon" :src="require('@/assets/images/center/Wallet_balance.png')" alt="" />
                    <span>${{ userInfo.user.walletBalance }}</span>
                </div> -->
                <div class="select flex-center popover-case">
                    <language />
                </div>
                <div class="user-info flex-center popover-case" @click="jumpPage('/account/profile')">
                    
                    <el-dropdown class="flex-center">
                         <!-- <span>{{ userInfo.user.userName }}</span> -->
                         <span><img class="avatar" :src="profile_avatar" alt="" /></span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item command="zh" @click="goMessage">{{ langrage['profile1']
                                }}</el-dropdown-item>
                                <el-dropdown-item command="es" @click="checkIn">{{ langrage['navbar4']
                                }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </template>

            <!-- 移动端显示简化版本 -->
            <template v-else>
                <div class="mobile-right-content">
                    <div class="notification-wrapper" @click="toggleNotificationPanel">
                        <el-badge class="badge" :value="badge" :max="99" :offset="[3, -1]">
                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                            </svg>
                        </el-badge>
                    </div>
                    <div class="mobile-language">
                        <language />
                    </div>
                    <!-- <div style="font-size: 1.4rem">{{ userInfo.user.userName }}</div>
                    <div class="mobile-user-info" @click="jumpPage('/account/profile')">
                        <img class="avatar" :src="profile_avatar" alt="" />
                    </div> -->
                </div>
                <div v-if="notificationVisible" class="mobile-notification-panel">
                    <div class="panel-header">
                        <h2>{{ langrage['dashboard31'] }}</h2>
                        <button @click="notificationVisible = false" class="close-btn">×</button>
                    </div>

                    <div class="panel-content">
                        <div v-if="userMessage.length" class="message-list">
                            <div v-for="(item, index) in userMessage" :key="index" class="message-item">
                                <div class="message-text">{{ item.pushInfo }}</div>
                                <div class="message-action" @click="changeType(item)"
                                    :class="item.isRead == 2 ? 'read' : 'unread'">
                                    {{ item.isRead == 2 ? langrage['dashboard36'] : langrage['dashboard35'] }}
                                </div>
                            </div>
                        </div>
                        <div v-else class="no-messages">
                            {{ langrage['dashboard38'] }}
                        </div>
                    </div>

                    <div v-if="userMessage.length" class="panel-footer">
                        <button @click="changeType('')" class="mark-all-read">
                            {{ langrage['dashboard32'] }}
                        </button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .blue {
        color: #2b6bff !important;
    }
    
    // 消息下拉框
    .el-popper {
        border-radius: 10px;
    }
    .popover_content {
        height: 30rem;
        background: #F5F2FF;
        border: 2px solid #f3f3f3;
        color: #281a47;
        padding: 1rem;
        border-radius: 10px;

        .popover_title {
            margin-bottom: 1rem !important;
            font-size: 1.6rem;
        }

        .popover_tip_content {
            max-height: 14rem;
            overflow-y: auto;
        }

        .popover_text_content {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .num_content {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .num {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 2rem;
                    margin: 0.2rem 0 0.2rem 0;
                }

                .popover_text {
                    margin: 0.2rem 0 0.2rem 0;
                }

            }

            .popover_type {
                color: #ccc;
                cursor: pointer;
            }
        }

        .popover_botton_content {
            padding-top: 1rem;
        }
    }

    // otf-opentype
    // ttf-truetype
    @font-face {
        font-family: 'Custom1';
        src: url('@/assets/fonts/1.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom2';
        src: url('@/assets/fonts/2.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom3';
        src: url('@/assets/fonts/3.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom4';
        src: url('@/assets/fonts/4.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom5';
        src: url('@/assets/fonts/5.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom6';
        src: url('@/assets/fonts/6.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom7';
        src: url('@/assets/fonts/7.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom8';
        src: url('@/assets/fonts/8.otf') format('opentype');
    }

    ::v-deep {
        .el-breadcrumb {
            font-size: 1.4rem;
        }
    }

    .scroll {
        border: 1px solid red;
        width: 50rem;
        overflow: hidden;
    }

    .navbar {
        position: fixed;
        z-index: 9;
        width: -webkit-fill-available;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 7rem;
        background: #ffffff;
        box-shadow: inset 0rem -0.1rem 0rem 0rem #f0f0f0;
        box-sizing: border-box;
        padding: 0 2rem;

        .left {
            .icon {
                width: 4rem;
                height: 4rem;
                line-height: 5.4rem;
                text-align: center;
                cursor: pointer;

                img {
                    width: 2rem;
                    height: 2rem;
                }
            }

            .tips {
                font-weight: 400;
                font-size: 1.4rem;
                color: #333333;
                margin-left: 5rem;
            }
        }

        .right {
            .btn {
                cursor: pointer;
                min-width: 10rem;
                height: 3.2rem;
                background: #fff;
                border-radius: 0.5rem;
                border: 0.1rem solid #23E7A8;
                font-weight: 400;
                font-size: 1.4rem;
                color: #333333;

                .icon {
                    width: 2.5rem;
                    height: 2.5rem;
                }

                span {
                    // margin: 0 0.5rem 0 1rem;
                    font-weight: 400;
                    font-size: 1.4rem;
                    color: #333333;
                    white-space: nowrap;
                }
            }

            .popover-case {
                height: 2.5rem;
                min-width: 2.5rem;
                display: flex;
                align-items: center;
                border-radius: 10px;
                padding: 0.7rem;
                background: var(--bg-app);
                border: 1px solid var(--border-light);
                display: grid;
                place-items: center;
                color: var(--text-grey);
                transition: all 0.2s var(--ease);
                position: relative;
            }
            
            .popover-case:hover {
                color: var(--primary);
                border-color: var(--primary);
                background: var(--primary-bg);
            }

            .badge {
                // margin: 0 2.5rem 0 1.5rem;
                cursor: pointer;
            }

            .user-info {
                cursor: pointer;
                margin-right: 1rem;
                padding: 0.7rem 1rem;
                display: flex;

                span {
                    font-weight: 500;
                    font-size: 1.4rem;
                }

                .avatar {
                    width: 2rem;
                    height: 2rem;
                    border-radius: 50%;
                }
            }

            .select {
                cursor: pointer;
                background: linear-gradient(35deg, #1A1532 0%, #2D1B4E 50%, #4B1E50 100%);

                ::v-deep {
                    .language-box {
                        position: relative;
                        top: auto;
                        right: auto;
                    }
                }

                img {
                    width: 3rem;
                    height: 2rem;
                    margin-right: 1rem;
                }

                .el-dropdown-link {
                    font-weight: 400;
                    font-size: 1.2rem;
                    color: #333333;
                }

                .el-dropdown-link:focus-visible {
                    outline: none;
                }
            }
        }
    }

    ::v-deep {
        .el-dropdown-menu__item {
            font-size: 1.4rem;
        }

        .el-dropdown-menu__item:not(.is-disabled):focus,
        .el-dropdown-menu__item:not(.is-disabled):hover {
            color: #2b6bff;
        }

        .is-text {
            border: 1px solid #ccc !important;
        }
    }

    .flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
    }

    // 移动端样式
    .mobile-menu-icon {
        width: 4rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
            width: 2rem;
            height: 2rem;
        }
    }

    .mobile-right-content {
        display: flex;
        align-items: center;
        gap: 1rem;

        .badge {
            margin: 0;
        }

        .mobile-user-info {
            .avatar {
                width: 3rem;
                height: 3rem;
                border-radius: 50%;
            }
        }

        .mobile-language {
            ::v-deep {
                .language-box {
                    position: relative;
                    top: auto;
                    right: auto;
                    margin: 0;

                    .el-dropdown {
                        .el-dropdown-link {
                            color: #333;
                            font-size: 1.4rem;

                            img {
                                width: 2rem;
                                height: 1.5rem;
                                margin-right: 0.5rem;
                            }
                        }
                    }
                }
            }
        }
    }

    /* ============== RESPONSIVE - 移动端 (max-width: 768px) ============== */
    @media screen and (max-width: 768px) {
        .navbar {
                .left .icon {
                    display: none;
                }
        
                .tips {
                    display: none;
                }
        
                .right {
        
                    // 隐藏桌面端内容
                    :deep(.btn),
                    :deep(.select),
                    :deep(.user-info) {
                        display: none;
                    }
                }
            }
            
        .mobile-menu-icon {
            display: none;
        }
        :root {
            --topbar-h: 60px;
        }

        .navbar {
            height: 60px;
            padding: 0 16px;
            gap: 8px;
            background: #0E0E18;
            box-shadow: none;
            border-bottom: 1px solid rgba(15, 15, 26, 0.15);

            .left {
                gap: 12px;

                .mobile-menu-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: rgba(139, 92, 246, 0.15);
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 20px;
                        height: 20px;
                        filter: brightness(0) invert(1);
                    }
                }
            }

            .right {
                .mobile-right-content {
                    gap: 8px;

                    .notification-wrapper {
                        transform: translateY(0.1rem);
                        color: #FFFFFF;
                        
                        &:hover {
                           color: var(--primary); 
                        }
                        
                        .badge {
                            :deep(.el-badge__content) {
                                background: #FF4D9D;
                                color: #FFFFFF;
                                font-size: 10px;
                                min-width: 16px;
                                height: 16px;
                                line-height: 16px;
                                border-radius: 8px;
                            }
                        }
                    }

                    .mobile-language {
                        ::v-deep {
                            .language-box {
                                .el-dropdown {
                                    .el-dropdown-link {
                                        color: rgba(255, 255, 255, 0.8);
                                        font-size: 12px;

                                        img {
                                            width: 18px;
                                            height: 12px;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .mobile-user-info {
                        .avatar {
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            border: 2px solid rgba(139, 92, 246, 0.5);
                        }
                    }
                }
            }
        }

        .mobile-notification-panel {
            top: 56px;
            width: calc(100% - 32px);
            left: 16px;
            right: 16px;
            border-radius: 14px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);

            .panel-header {
                padding: 14px 16px;
                border-bottom: 1px solid rgba(15, 15, 26, 0.1);
                background: linear-gradient(135deg, rgba(139, 92, 246, 0.05) 0%, rgba(255, 77, 157, 0.05) 100%);

                h3 {
                    font-size: 15px;
                    font-weight: 600;
                    color: #0F0F1A;
                }

                .close-btn {
                    font-size: 24px;
                    color: #9A9AB0;
                }
            }

            .panel-content {
                max-height: 280px;

                .message-list {
                    .message-item {
                        padding: 12px 16px;
                        border-bottom: 1px solid rgba(15, 15, 26, 0.06);

                        .message-text {
                            font-size: 13px;
                            color: #4A4A65;
                            line-height: 1.5;
                        }

                        .message-action {
                            font-size: 11px;
                            color: #9A9AB0;

                            &.unread {
                                color: #8B5CF6;
                                font-weight: 600;
                            }
                        }
                    }
                }

                .no-messages {
                    padding: 24px;
                    font-size: 13px;
                    color: #9A9AB0;
                }
            }

            .panel-footer {
                padding: 12px 16px;

                .mark-all-read {
                    background: linear-gradient(135deg, #8B5CF6 0%, #FF4D9D 100%);
                    color: #FFFFFF;
                    padding: 8px 16px;
                    border-radius: 8px;
                    font-size: 13px;
                    font-weight: 600;
                    transition: transform 0.2s, box-shadow 0.2s;

                    &:hover {
                        transform: translateY(-1px);
                        box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
                    }
                }
            }
        }
    }

    .mobile-notification-panel {
        position: absolute;
        top: 6rem;
        right: 0rem;
        left: 0rem;
        margin: auto;
        width: 85%;
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        z-index: 100;

        .panel-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1rem;
            border-bottom: 1px solid var(--primary);

            h3 {
                margin: 0;
                font-size: 1.4rem;
            }

            .close-btn {
                background: none;
                border: none;
                font-size: 4rem;
                cursor: pointer;
            }
        }

        .panel-content {
            max-height: 300px;
            overflow-y: auto;

            .message-list {
                .message-item {
                    padding: 1rem;
                    border-bottom: 1px solid #eee;

                    .message-text {
                        margin-bottom: 0.5rem;
                    }

                    .message-action {
                        color: #ccc;
                        cursor: pointer;

                        &.unread {
                            color: #2b6bff;
                        }
                    }
                }
            }

            .no-messages {
                text-align: center;
                padding: 2rem;
                font-size: 1.4rem;
            }
        }

        .panel-footer {
            padding: 1rem;
            text-align: right;

            .mark-all-read {
                background: #2b6bff;
                color: white;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 4px;
                cursor: pointer;
            }
        }
    }

    .notification-wrapper {
        position: relative;
    }
</style>